import { render, staticRenderFns } from "./ChoiceMaxPoint.vue?vue&type=template&id=5627c4ae&scoped=true&"
import script from "./ChoiceMaxPoint.vue?vue&type=script&lang=js&"
export * from "./ChoiceMaxPoint.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceMaxPoint.vue?vue&type=style&index=0&id=5627c4ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627c4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRadio,VRadioGroup,VTextField})
